import Constanta from "../../config/constanta";
import Helper from "../../lib/helper";
import moment from "moment";
import React, { Component } from "react";
import { ActionCreators } from "../../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DatePicker from "react-date-picker";
import _ from "lodash";

import "moment/locale/en-au";

class ApplicantDetail extends Component {
  constructor(props) {
    super(props);

    this.formProcess = null;

    this.handleSubmitRecruitmentProcess = this.handleSubmitRecruitmentProcess.bind(
      this
    );

    this.state = {
      vacancyDetail: {
        jobTitle: ""
      },
      formProcess: {
        vacancyId: "",
        processStart: new Date(),
        processStatus: "0",
        processType: "0",
        note: "",
        recruiter: ""
      },
      applicant: {}
    };

    this.comboProcessType = [
      {
        id: 1,
        label: "Online Test"
      },
      {
        id: 2,
        label: "Interview"
      }
    ];
    this.comboProcessStatus = [
      {
        id: 1,
        label: "Invitation sent"
      },
      {
        id: 2,
        label: "Invitation not attended"
      },
      {
        id: 3,
        label: "Passed"
      },
      {
        id: 4,
        label: "Failed"
      },
      {
        id: 5,
        label: "Keep In View"
      }
    ];
  }

  async componentDidMount() {
    this.props.jobLocation();
    let applicant_param = this.props.location.applicant; 
    let vacancyDetail = {};

    if (applicant_param) {
      let formProcess = { ...this.state.formProcess };
      formProcess.vacancyId = applicant_param.vacancyId;
      let vacanciesPL = await this.props.vacanciesPLAction();
      if (vacanciesPL) {
        vacancyDetail = vacanciesPL.find(
          v => v.id === applicant_param.vacancyId
        );
      }
      this.setState(prevState => ({
        ...prevState,
        applicant: applicant_param,
        formProcess: formProcess,
        vacancyDetail: vacancyDetail
      }));
    } else {
      this.props
        .getApplicantByIdAction(this.props.match.params.id)
        .then(async () => {
          if (this.props.applicant) {
            let formProcess = { ...this.state.formProcess };
            formProcess.vacancyId = this.props.applicant.vacancyId;
            let vacanciesPL = await this.props.vacanciesPLAction();
            if (vacanciesPL) {
              vacancyDetail = vacanciesPL.find(
                v => v.id === this.props.applicant.vacancyId
              );
            }
            this.setState(prevState => ({
              ...prevState,
              applicant: this.props.applicant,
              formProcess: formProcess,
              vacancyDetail: vacancyDetail
            }));
          }
        });
    }
  }

  getProcessName = (id) => {
    const procs = _.find(this.comboProcessStatus, v => v.id === id);
    if(procs !== undefined) {
      return procs.label;
    }

    return "";
  }

  getPreferredLocation = (id) => {
    if(id === "00000000-0000-0000-0000-000000000000") return "Both";

    return this.props.jobLocations.find(
      l => l.id === id
    ).location
  }

  getCurrentSalary(employments) {
    if (employments.length === 0) {
      return "-";
    }

    const currentCompany = _.find(employments, empl => empl.isCurrent === true);
    if (currentCompany !== undefined && currentCompany !== null) {
      return currentCompany.salary.formatMoney(0, "", ".");
    }

    const lastCompany = _.orderBy(employments, empl => empl.periodEnd, [
      "desc"
    ]);
    return lastCompany[0].salary.formatMoney(0, "", ".");
  }

  getTypeName = (id) => {
    const procs = _.find(this.comboProcessType, v => v.id === id);
    if(procs !== undefined) {
      return procs.label;
    }

    return "";
  }

  handleSubmitRecruitmentProcess(e) {
    e.preventDefault();
    if(this.state.formProcess.processStatus === "0"
      || this.state.formProcess.processType === "0"
      || this.state.formProcess.recruiter === "") {
        alert("processStatus or processType or recruiter cannot empty");
    } else {
      this.props.postApplicantProcessAction(
        this.state.applicant.id,
        this.state.formProcess
      );
      const formProcess = {
        processStart: new Date(),
        processStatus: "0",
        processType: "0",
        note: "",
        recruiter: ""
      };
      this.setState({
        formProcess: formProcess
      });
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-6">
          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Personal Information
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card mt-3 mb-3">
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">Applied As</div>
                    <div className="col-8">
                      <strong>
                        {this.state.vacancyDetail.jobTitle !== ""
                          ? this.state.vacancyDetail.jobTitle
                          : ""}
                      </strong>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Full name</div>
                    <div className="col-8">
                      {this.state.applicant.firstName +
                        " " +
                        this.state.applicant.lastName}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Email</div>
                    <div className="col-8">{this.state.applicant.email}</div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Phone number</div>
                    <div className="col-8">
                      {this.state.applicant.phoneNumber}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Current address</div>
                    <div className="col-8">
                      {this.state.applicant.currentAddress}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Birth date</div>
                    <div className="col-8">
                      {
                        this.state.applicant.birthDate
                          && moment(new Date(this.state.applicant.birthDate)).format('LL')
                      }
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Currently employed</div>
                    <div className="col-8">
                      {this.state.applicant.isEmployed ? "Yes" : "No"}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Skills</div>
                    <div className="col-8">{this.state.applicant.skills}</div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Linkedin</div>
                    <div className="col-8">{this.state.applicant.linkedin}</div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Online portfolio</div>
                    <div className="col-8">
                      {this.state.applicant.onlinePortfolio}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Experiences
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card mt-3 mb-3">
                <div className="card-body">
                  <ol>
                    {this.state.applicant.employments &&
                      this.state.applicant.employments.map((e, i) => {
                        return (
                          <li key={i}>
                            <b>{e.companyName}</b>
                            <br />
                            <span>{e.jobTitle}</span>
                            <br />
                            <div
                              dangerouslySetInnerHTML={{ __html: e.jobDesc }}
                            />
                            <br />
                            <span>
                              from{" "}
                              {moment(new Date(e.periodStart)).format("LL")}{" "}
                              until{" "}
                              {e.isCurrent
                                ? "current"
                                : moment(new Date(e.periodEnd)).format("LL")}
                            </span>
                            <br />
                            <span>IDR {Helper.numberFormatter(e.salary)}</span>
                            <br />
                            <b>Project(s) : </b>
                            <br />
                            <ul>
                              {e.projects &&
                                e.projects.map((p, j) => {
                                  return (
                                    <li key={j}>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: p.description
                                        }}
                                      />
                                      <br />
                                      <span>
                                        from{" "}
                                        {moment(new Date(p.periodStart)).format(
                                          "LL"
                                        )}{" "}
                                        until{" "}
                                        {moment(new Date(p.periodEnd)).format(
                                          "LL"
                                        )}
                                      </span>
                                      <br />
                                      <strong>{p.techs}</strong>
                                      <br />
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: p.roles
                                        }}
                                      />
                                    </li>
                                  );
                                })}
                            </ul>
                          </li>
                        );
                      })}
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Educations
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card mt-3 mb-3">
                <div className="card-body">
                  <ol>
                    {this.state.applicant.educations &&
                      this.state.applicant.educations.map((e, i) => {
                        return (
                          <li key={i}>
                            {e.type === Constanta.educationtype.UNIVERSITY && (
                              <div className="row">
                                <div className="col">
                                  <span>{e.major + " of " + e.university}</span>
                                  <br />
                                  <span>
                                    From{" "}
                                    {moment(new Date(e.periodStart)).format(
                                      "LL"
                                    )}{" "}
                                    to{" "}
                                    {moment(new Date(e.periodEnd)).format(
                                      "LL"
                                    )}
                                  </span>
                                  <br />
                                  <span>GPA {e.gpa} in sclae of 4</span>
                                  <br />
                                  <div style={{ whiteSpace: "pre-wrap" }}>
                                    {e.final}
                                  </div>
                                  <br />
                                </div>
                              </div>
                            )}
                            {e.type !== Constanta.educationtype.UNIVERSITY && (
                              <div className="row">
                                <div className="col">
                                  <span>{e.certificateName}</span>
                                  <br />
                                  <span>
                                    {moment(new Date(e.receivedDate)).format(
                                      "LL"
                                    )}
                                  </span>
                                </div>
                              </div>
                            )}
                          </li>
                        );
                      })}
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Additional Information
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card mt-3 mb-3">
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">Preferred work location</div>
                    <div className="col-8">
                      {this.state.applicant.location && this.getPreferredLocation(this.state.applicant.location)}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Current salary (net)</div>
                    <div className="col-8">
                      {this.state.applicant.employments && "IDR " + this.getCurrentSalary(this.state.applicant.employments)}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Current salary (net)</div>
                    <div className="col-8">
                      {this.state.applicant.employments && "IDR " + this.getCurrentSalary(this.state.applicant.employments)}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Expected salary (net)</div>
                    <div className="col-8">
                      {"IDR " +
                        Helper.numberFormatter(this.state.applicant.salary)}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Notice period requirement</div>
                    <div className="col-8">
                      {this.state.applicant.noticePeriod !== undefined
                        ? Constanta.noticePeriodOption.find(
                            x => x.notice === this.state.applicant.noticePeriod
                          ).name
                        : null}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Leaving reason</div>
                    <div className="col-8" style={{ whiteSpace: "pre-wrap" }}>
                      {this.state.applicant.reasonLeaving}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-4">Refference</div>
                    <div className="col-8">
                      {this.state.applicant.referral !== undefined
                        ? Constanta.referralOption.find(
                            x => x.referral === this.state.applicant.referral
                          ).name
                        : null}
                      <br />
                      {this.state.applicant.referralOther}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
        { this.state.applicant.recruitmentProcesses &&
          this.state.applicant.recruitmentProcesses.length > 0 &&
          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Recruitment Process Histories
              </button>
            </div>
          </div>
        }

          {this.state.applicant.recruitmentProcesses &&
          this.state.applicant.recruitmentProcesses.length > 0
            ? this.state.applicant.recruitmentProcesses.map((x, i) => (
                <div className="row">
                  <div className="col">
                    <div className="card mt-3 mb-3">
                      <div className="card-body" key={i}>
                        <div class="row">
                          <div class="col-4">Process On</div>
                          <div class="col-8">
                            {moment(new Date(x.processStart)).format("LL")}
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-4">Recruiter By</div>
                          <div class="col-8">{x.recruiter}</div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-4">Test Type</div>
                          <div class="col-8">{this.getTypeName(x.type)}</div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-4">Status</div>
                          <div class="col-8">
                          {
                            this.getProcessName(x.processStatus)
                          }
                          </div>
                        </div>
                        <hr />
                        <div class="row">
                          <div class="col-4">Note</div>
                          <div class="col-8">{x.note}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : null}

          <div className="row">
            <div className="col">
              <button type="button" disabled className="gs-btn gs-btn-blue">
                Recruitment Process Form
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card mt-3 mb-3">
                <div className="card-body">
                  <form
                    onSubmit={this.handleSubmitRecruitmentProcess}
                    ref={form => (this.formProcess = form)}
                  >
                    <input
                      type="hidden"
                      name="applicantId"
                      value={this.state.formProcess.vacancyId}
                    />
                    <div className="">
                      <div className="form-field">
                        <label>Process Start</label>
                        <DatePicker
                          value={this.state.formProcess.processStart}
                          onChange={e => {
                            const formProcess = { ...this.state.formProcess };
                            formProcess.processStart = e;
                            this.setState({
                              formProcess: formProcess
                            });
                          }}
                          calendarIcon={
                            <i className="icon-calendar text-blue" />
                          }
                          clearIcon={<i className="icon-close" />}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="">
                      <div className="form-field">
                        <label>Process Type</label>
                        <select
                          onChange={e => {
                            const formProcess = { ...this.state.formProcess };
                            formProcess.processType = e.target.value;
                            this.setState({
                              formProcess: formProcess
                            });
                          }}
                          value={this.state.formProcess.processType}
                        >
                          <option value="0">Please Select</option>
                          {this.comboProcessType.map(x => {
                            return (
                              <option key={x.id} value={x.id}>
                                {x.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <hr />
                    <div className="">
                      <div className="form-field">
                        <label>Recruiter</label>
                        <input
                          type="text"
                          name="recruiter"
                          onChange={e => {
                            const formProcess = { ...this.state.formProcess };
                            formProcess.recruiter = e.target.value;
                            this.setState({
                              formProcess: formProcess
                            });
                          }}
                          value={this.state.formProcess.recruiter}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="">
                      <div className="form-field">
                        <label>Process Status</label>
                        <select
                          onChange={e => {
                            const formProcess = { ...this.state.formProcess };
                            formProcess.processStatus = e.target.value;
                            this.setState({
                              formProcess: formProcess
                            });
                          }}
                          value={this.state.formProcess.processStatus}
                        >
                          <option value="0">Please Select</option>
                          {this.comboProcessStatus.map(x => {
                            return (
                              <option key={x.id} value={x.id}>
                                {x.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <hr />
                    <div className="">
                      <div className="form-field">
                        <label>Note</label>
                        <textarea
                          onChange={e => {
                            const formProcess = { ...this.state.formProcess };
                            formProcess.note = e.target.value;
                            this.setState({
                              formProcess: formProcess
                            });
                          }}
                          value={this.state.formProcess.note}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="">
                      <div className="">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    applicant: state.applicant,
    vacanciesPL: state.vacanciesPL,
    jobLocations: state.jobLocations
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ApplicantDetail)
);



// WEBPACK FOOTER //
// ./src/pages/auth/applicantDetail.js